import { render, staticRenderFns } from "./SendForCreatorReview.vue?vue&type=template&id=3b00d283"
import script from "./SendForCreatorReview.vue?vue&type=script&lang=js"
export * from "./SendForCreatorReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports